<template>
	<div class="readme">
		<van-nav-bar title="盼之代售用户协议" left-arrow @click-left="back" fixed placeholder/>
		<div class="content" v-html="readme.content"></div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			readme: {
				title: '服务协议',
				content:
					'<p>一、总则</p><p>1.1　用户应当同意本协议的条款并按照页面上的提示完成全部的注册程序。用户在进行注册程序过程中勾选"我已阅读并接受"模块即表示用户与产品名称达成协议，完全接受本协议项下的全部条款。</p><p>1.2　用户注册成功后，产品名称将给予每个用户一个用户帐号及相应的密码，该用户帐号和密码由用户负责保管；用户应当对以其用户帐号进行的所有活动和事件负法律责任。</p><p>1.3　用户可以使用产品名称各个频道单项服务，当用户使用产品名称各单项服务时，用户的使用行为视为其对该单项服务的服务条款以及产品名称在该单项服务中发出的各类公告的同意。</p><p>二、注册信息和隐私保护</p><p>2.1　产品名称帐号（即产品名称用户ID）的所有权归产品名称，用户完成注册申请后，获得产品名称帐号的使用权。所有原始键入的资料将引用为注册资料。如果因注册信息不真实而引起的问题，并对问题发生所带来的后果，产品名称不负任何责任。</p><p>2.2 &nbsp; 注销账户本软件删除您的个人信息，为了您的信息全部清空请联系客服进行账号注销，此时我们会在15个工作日内将您的个人账号信息进行清除。注销的时效性：用户同意注销后立即生效，15个工作日情况所有信息。</p><p>2.2　用户不应将其帐号、密码转让或出借予他人使用。如用户发现其帐号遭他人非法使用，应立即通知产品名称。因黑客行为或用户的保管疏忽导致帐号、密码遭他人非法使用，产品名称不承担任何责任。</p><p>2.3　产品名称不对外公开或向第三方提供单个用户的注册资料。</p><p>三、使用规则</p><p>3.1　用户在使用产品名称服务时，必须遵守中华人民共和国相关法律法规的规定，用户应同意将不会利用本服务进行任何违法或不正当的活动.</p><p>3.2　用户违反本协议或相关的服务条款的规定，导致或产生的任何第三方主张的任何索赔、要求或损失，包括合理的律师费，您同意赔偿数据堂与合作公司、关联公司，并使之免受损害。</p><p>3.3　用户不得对本服务任何部分或本服务之使用或获得，进行复制、拷贝、出售、转售或用于任何其它商业目的。</p><p>3.4　用户须对自己在使用产品名称服务过程中的行为承担法律责任。</p><p>四、服务内容</p><p>4.1　产品名称网络服务的具体内容由产品名称根据实际情况提供。</p><p>4.2　除非您与产品名称另有约定，您同意本服务仅为您个人非商业性质的使用。</p><p>4.3　产品名称的部分服务是以收费方式提供的，如您使用收费服务，请遵守相关的协议。</p><p>4.4　产品名称可能根据实际需要对收费服务的收费标准、方式进行修改和变更，产品名称也可能会对部分免费服务开始收费。</p><p>4.5　产品名称网络需要定期或不定期地对提供网络服务的平台或相关的设备进行检修或者维护，如因此类情况而造成网络服务（包括收费网络服务）在合理时间内的中断，产品名称网络无需为此承担任何责任。产品名称网络保留不经事先通知为维修保养、升级或其它目的暂停本服务任何部分的权利。</p><p>4.6　本服务或第三人可提供与其它国际互联网上之网站或资源之链接。</p><p>4.7　产品名称网络对在服务网上得到的任何商品购物服务、交易进程、招聘信息，都不作担保。</p><p>4.8　产品名称网络有权于任何时间暂时或永久修改或终止本服务（或其任何部分）。</p><p>4.9　终止服务</p><p>您同意产品名称得基于其自行之考虑，因任何理由，包含但不限于产品名称认为您已经违反本服务协议的文字及精神，终止您的密码、帐号或本服务之使用（或服务之任何部分），并将您在本服务内任何内容加以移除并删除。您同意依本服务协议任何规定提供之本服务，无需进行事先通知即可中断或终止，您承认并同意，产品名称可立即关闭或删除您的帐号及您帐号中所有相关信息及文件，或禁止继续使用前述文件或本服务。此外，您同意若本服务之使用被中断或终止或您的帐号及相关信息和文件被关闭或删除，产品名称对您或任何第三人均不承担任何责任。</p><p>五、知识产权和其他合法权益（包括但不限于名誉权、商誉权）</p><p>5.1　产品名称在本服务中提供的内容（包括但不限于网页、文字、图片、音频、视频、图表等）的知识产权归产品名称所有，用户在使用本服务中所产生的内容的知识产权归用户或相关权利人所有。</p><p>5.2 除另有特别声明外，产品名称提供本服务时所依托软件的著作权、专利权及其他知识产权均归产品名称所有。</p><p>六、未成年人使用条款</p><p>6.1 若用户未满18周岁，则为未成年人，应在监护人监护、指导下阅读本协议和使用本服务。</p><p>6.2 未成年人用户涉世未深，容易被网络虚象迷惑，且好奇心强，遇事缺乏随机应变的处理能力，很容易被别有用心的人利用而又缺乏自我保护能力。因此，未成年人禁止使用。</p>',
			},
		};
	},
	methods: {
		back() {
			this.$router.go(-1);
		},
	},
};
</script>

<style lang="less" scoped>
.readme {
    height: 100vh;
    .content {
        padding: 10px;
    }
}
</style>
